import { createSlice } from "@reduxjs/toolkit";

// type = ['normal','image','background']

const normaliseOnlineUserId = (value) => {
  if (!value) return "";
  if (typeof value === "object") {
    if (value._id) return normaliseOnlineUserId(value._id);
    if (value.id) return normaliseOnlineUserId(value.id);
  }
  return String(value);
};

const mergeOnlineUser = (existing = {}, incoming = {}) => {
  const id =
    normaliseOnlineUserId(incoming.id || incoming._id) ||
    normaliseOnlineUserId(existing.id || existing._id);

  const firstName =
    incoming.first_name ||
    incoming.firstName ||
    existing.first_name ||
    existing.firstName ||
    "";
  const lastName =
    incoming.last_name ||
    incoming.lastName ||
    existing.last_name ||
    existing.lastName ||
    "";

  return {
    ...existing,
    ...incoming,
    id,
    _id: normaliseOnlineUserId(incoming._id || existing._id || id),
    username: incoming.username || existing.username || "",
    guid: incoming.guid ?? existing.guid ?? incoming.legacyGuid ?? existing.legacyGuid ?? null,
    legacyGuid: incoming.legacyGuid ?? existing.legacyGuid ?? incoming.guid ?? existing.guid ?? null,
    first_name: firstName,
    last_name: lastName,
    firstName: incoming.firstName || incoming.first_name || existing.firstName || existing.first_name || "",
    lastName: incoming.lastName || incoming.last_name || existing.lastName || existing.last_name || "",
    photo: incoming.photo || incoming.avatarUrl || existing.photo || existing.avatarUrl || "",
  };
};

const mergeOnlineUserList = (list = []) => {
  const merged = new Map();

  list.forEach((entry) => {
    const id = normaliseOnlineUserId(entry?.id || entry?._id);
    if (!id) return;
    merged.set(id, mergeOnlineUser(merged.get(id), entry));
  });

  return Array.from(merged.values());
};

const initialValue = {
  onlineUsers: [],
  selectedChat: null,
};
export const createSoketSlice = createSlice({
  name: "soketSlice",
  initialState: initialValue,

  reducers: {
    setOnlineUsers: (state, action) => {
      const { type, info } = action.payload;
      const incomingId = normaliseOnlineUserId(info?.id || info?._id);

      if (type === "add") {
        const existingIndex = state.onlineUsers.findIndex(
          (u) => normaliseOnlineUserId(u?.id || u?._id) === incomingId
        );

        if (existingIndex >= 0) {
          state.onlineUsers[existingIndex] = mergeOnlineUser(
            state.onlineUsers[existingIndex],
            info
          );
        } else if (incomingId) {
          state.onlineUsers = [...state.onlineUsers, mergeOnlineUser({}, info)];
        }
      } else if (type === "remove") {
        state.onlineUsers = state.onlineUsers.filter(
          (u) => normaliseOnlineUserId(u?.id || u?._id) !== incomingId
        );
      } else if (type === "connect") {
        state.onlineUsers = mergeOnlineUserList(Array.isArray(info) ? info : []);
      }
    },
    setSelectedChat: (state, action) => {
      state.selectedChat = action.payload;
    },
  },
});
export const { setOnlineUsers, setSelectedChat } = createSoketSlice.actions;

export default createSoketSlice.reducer;
export const __private = {
  normaliseOnlineUserId,
  mergeOnlineUser,
  mergeOnlineUserList,
};
